module.exports = __webpack_public_path__ + "static/media/darktrace.581539ee.png";